import React from "react";
import { Image } from "./helperFunctions";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendarAlt } from "@fortawesome/free-solid-svg-icons";
import { navigate } from "hookrouter";

export const EventCard = ({ data, title, day, time }) => {
  const conducted =
    data?.Conducted ||
    new Date(data.Date).setHours(0, 0, 0, 0) < new Date().setHours(0, 0, 0, 0);

  const getId = (event)=>{
    let id;
    // event.id ? id=`id/${event.id}` : id=`_id/${event._id}`;
    id=`_id/${event.id}`;
    console.log(id)
    return id 
  }
  return (
    <button
      onClick={() => navigate(`/events/${getId(data)}`)}
      className="flex mx-2 sm:mx-4 lg:mx-8 card-container w-full max-w-xs hover:shadow-2xl transition duration-300 relative overflow-hidden bg-white focus:outline-none rounded-lg mb-4 md:mb-8 lg:mb-16"
    >
      <div className="w-full  h-full">
        <Image
          src={data?.Event_Poster}
          style={{ height: "250px" }}
          className="object-cover rounded-lg border shadow-xl hover:shadow-2xl transiton duration-300 border-blue-200 w-full"
        />
      </div>

      <div
        className={`absolute card-hover rounded-lg flex w-full h-full bg-gradient-to-b ${
          conducted ? "from-blue-800 to-blue-600" : "from-pink-700 to-pink-500"
        } item-center text-center left-0  text-3xl font-medium text-white hover:bg-opacity-100 hover:opacity-100  transition-all duration-200 ease-in`}
      >
        <div className="w-full flex h-full flex-wrap my-auto">
          <div className="flex justify-center pt-2 text-sm w-full">
            {conducted ? "This event is Over" : "Upcoming"}
          </div>
          <div className="text-center relative h-1/2 flex flex-wrap w-full justify-center items-center my-auto">
            <span className="max-w-full break-words">{title}</span>
            <div className="flex absolute bottom-0 w-full">
              <div className="w-full mx-6 h-1 border-t border-white"></div>
            </div>
          </div>
          <div className="flex flex-wrap h-1/2 items-center justify-center w-full">
            <div className="flex -mt-8 justify-center">
              <FontAwesomeIcon icon={faCalendarAlt} className="text-xs mr-4" />
              <div className="text-6xl mr-2 flex">{day[1]}</div>
              <div className="text-lg mt-auto flex-1">
                <div>{day[0]}</div>
                <div>{time}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </button>
  );
};
